import { render, staticRenderFns } from "./doImportCreateFee.vue?vue&type=template&id=1e4a0647"
import script from "./doImportCreateFee.vue?vue&type=script&lang=js"
export * from "./doImportCreateFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports